import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { Grid, TextField, FormHelperText } from '@mui/material';
import { Clock } from 'lucide-react';
import { CreateBookingDTO } from '../../../../types/booking';
import SectionTitle from './SectionTitle';

interface TimeSectionProps {
  control: Control<CreateBookingDTO>;
  disabled?: boolean;
}

const TimeSection: React.FC<TimeSectionProps> = ({ control, disabled = false }) => {
  return (
    <div>
      <SectionTitle icon={Clock} title="Select Time" />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Controller
            name="title"
            control={control}
            rules={{ required: 'Title is required' }}
            render={({ field, fieldState: { error } }) => (
              <>
                <TextField
                  {...field}
                  label="Booking Title"
                  fullWidth
                  error={!!error}
                  helperText={error?.message}
                  disabled={disabled}
                />
              </>
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="description"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Description (Optional)"
                fullWidth
                multiline
                rows={2}
                disabled={disabled}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="startTime"
            control={control}
            rules={{ required: 'Start time is required' }}
            render={({ field, fieldState: { error } }) => (
              <>
                <TextField
                  {...field}
                  type="datetime-local"
                  label="Start Time"
                  disabled={disabled}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  error={!!error}
                />
                {error && <FormHelperText error>{error.message}</FormHelperText>}
              </>
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="endTime"
            control={control}
            disabled={disabled}
            rules={{ required: 'End time is required' }}
            render={({ field, fieldState: { error } }) => (
              <>
                <TextField
                  {...field}
                  type="datetime-local"
                  label="End Time"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  error={!!error}
                />
                {error && <FormHelperText error>{error.message}</FormHelperText>}
              </>
            )}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default TimeSection;
